import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingContact = () => {
  return (
    <a
      href="https://wa.me/918822367580" // opens WhatsApp chat directly
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 bg-[#25D366] hover:bg-[#1EBE5D] text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 z-50 animate-pulse"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};

export default FloatingContact;
